import { useState, useEffect } from 'react';
import { useBooking } from '../context/BookingContext';

export default function MobileBar() {
  const [visible, setVisible] = useState(false);
  const { openModal } = useBooking();

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > window.innerHeight * 0.7);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-bar"
      className="md:hidden"
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 90,
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        transition: 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <button
        onClick={openModal}
        data-testid="mobile-sticky-cta"
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '100%', height: '56px',
          backgroundColor: '#5C2424', color: '#FAF5EF',
          fontFamily: 'Graphik, sans-serif', fontWeight: 700,
          fontSize: '12px', letterSpacing: '1.5px',
          textTransform: 'uppercase', border: 'none', cursor: 'pointer',
        }}
      >
        Book Miso Mini — ₹18,000 →
      </button>
    </div>
  );
}
